import { ComponentPropsWithoutRef, forwardRef } from "react";
import classNames from "classnames";

import { StyledDot } from "./Dot.styled";

export type DotProps = ComponentPropsWithoutRef<"div"> & {
  /**
   * Set dot color
   *
   * @type {"orange" | "blue" | "green" | "grey" | "red" | "yellow" | "light-grey"}
   */
  color?: "orange" | "blue" | "green" | "grey" | "red" | "yellow" | "light-grey";
};

const defaultProps: DotProps = {
  color: "orange"
};

const Dot = forwardRef<HTMLDivElement, DotProps>((props, ref) => {
  const { className, color, ...restProps } = props;
  const dotClass = classNames("c-dot", className);

  return <StyledDot data-testid="qa-dot" ref={ref} className={dotClass} color={color} {...restProps} />;
});

Dot.defaultProps = defaultProps;

export default Dot;
